/* Loëla — petits ajustements d'affichage (copie AH26 — Audit conversion). Agence Conversion & design.
   v1 — 2026-10-14 : maquettes Figma 5:7 (fiche produit) et 9:81 (collection).
   v2 — 2026-10-14 : « Dernières pièces » sur la fiche selon la variante choisie (arbitrage de Valentin).
   Grille : agencies/conversion/controles/2026-10-14_grille-produit-collection.md
   Ne modifie aucune donnée (prix, stock, variantes) : uniquement des libellés et des classes d'affichage. */
(function () {
  'use strict';

  function each(sel, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  /* Bandeau : étoiles dorées (« ★★★★★ » isolé dans un span) */
  function stars() {
    each('.announcement-bar a, .announcement-bar p', function (el) {
      if (el.querySelector('.loela-stars')) return;
      for (var i = 0; i < el.childNodes.length; i++) {
        var n = el.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.indexOf('★★★★★') !== -1) {
          var parts = n.nodeValue.split('★★★★★');
          var frag = document.createDocumentFragment();
          frag.appendChild(document.createTextNode(parts[0]));
          var s = document.createElement('span');
          s.className = 'loela-stars';
          s.textContent = '★★★★★';
          frag.appendChild(s);
          frag.appendChild(document.createTextNode(parts.slice(1).join('★★★★★')));
          el.replaceChild(frag, n);
          break;
        }
      }
    });
  }

  /* Fiche : « Couleur : » / « Taille : » (espace insécable avant les deux-points) */
  function colons() {
    each('.product-info .variant-picker__option-info', function (info) {
      var walker = document.createTreeWalker(info, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (/[^\s ]:\s*$/.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/\s*:(\s*)$/, ' :$1');
        }
      }
    });
  }

  /* Fiche : photos portrait recadrées en 340 × 470 sur mobile (les carrées restent entières) */
  function tallMedia() {
    each('.product-gallery__media', function (m) {
      var img = m.querySelector('img');
      if (!img) return;
      var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
      var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
      if (w && h && h / w >= 1.15) m.classList.add('loela-tall');
    });
  }

  /* Fiche : ligne Club « Club Loëla : gagnez N points avec cet article » */
  function club() {
    /* après un changement de modèle, l'appli réinjecte sa ligne près du prix : on la remet dans les rassurances */
    var p = document.querySelector('.rmf-points'), li = document.querySelector('.loela-reassure__club');
    if (p && li) {
      if (p.parentNode !== li) li.appendChild(p);
      if (li.hidden) li.hidden = false;
    }
    each('.loela-reassure__club .rmf-points span:not(.rmf-points__ic)', function (s) {
      var n = s.firstChild;
      if (n && n.nodeType === 3 && /^\s*Gagnez\s/.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/^\s*Gagnez\s/, 'Club Loëla : gagnez ');
      }
    });
  }

  /* Fiche : prix dans le bouton de la barre collante (mobile), format « 139 € » */
  function stickyPrice() {
    var src = document.querySelector('.product-info [data-block-id=price] sale-price');
    if (!src) return;
    var txt = '';
    for (var i = 0; i < src.childNodes.length; i++) {
      if (src.childNodes[i].nodeType === 3) txt += src.childNodes[i].nodeValue;
    }
    txt = txt.replace(/\s+/g, ' ').trim().replace(/,00(?=\s*€)/, '');
    each('product-sticky-bar buy-buttons .button', function (b) {
      if (txt) b.setAttribute('data-loela-price', txt); else b.removeAttribute('data-loela-price');
    });
  }

  /* Fiche : « Dernières pièces » quand la variante choisie n'a plus qu'une pièce (liste émise par theme.liquid) */
  var loelaVariant = '';
  function lastPiece() {
    var data = document.getElementById('loela-une-piece');
    var title = document.querySelector('.product-info .loela-title');
    if (!data || !title) return;
    var ids;
    try { ids = JSON.parse(data.textContent).map(String); } catch (e) { return; }
    var inp = document.querySelector('form[id^="product-form-main"] input[name="id"]');
    var id = loelaVariant || (inp ? String(inp.value) : '');
    var on = !!id && id !== '0' && ids.indexOf(id) !== -1;
    var badge = title.querySelector('.loela-stock--v');
    if (on && !badge) {
      badge = document.createElement('span');
      badge.className = 'loela-stock loela-stock--v';
      badge.textContent = 'Dernières pièces';
      title.appendChild(badge);
    } else if (!on && badge) {
      badge.parentNode.removeChild(badge);
    }
  }

  /* Collection : « Filtrer (n) » et « Trier : <tri en cours> » */
  function toolbar() {
    var f = document.querySelector('.collection-toolbar__button[aria-controls=facets-drawer]');
    if (f) {
      var params = new URLSearchParams(location.search), n = 0, price = false;
      params.forEach(function (v, k) {
        if (k.indexOf('filter.') !== 0 || v === '') return;
        if (k.indexOf('filter.v.price') === 0) { price = true; return; }
        n++;
      });
      if (price) n++;
      var label = 'Filtrer' + (n ? ' (' + n + ')' : '');
      if (f.getAttribute('data-loela') !== label) {
        f.textContent = label;
        f.setAttribute('data-loela', label);
      }
    }
    var sb = document.querySelector('.collection-toolbar__button[aria-controls=sort-by-popover] .text-with-icon');
    if (sb) {
      var opt = document.querySelector('#sort-by-popover [role=option][aria-selected=true]');
      var short = { 'created-descending': 'Nouveautés', 'created-ascending': 'Plus anciens', 'price-ascending': 'Prix croissant', 'price-descending': 'Prix décroissant', 'title-ascending': 'De A à Z', 'title-descending': 'De Z à A' };
      var name = opt ? (short[opt.getAttribute('value')] || opt.textContent.replace(/\s+/g, ' ').trim()) : '';
      if (name) {
        var span = sb.querySelector('.loela-sort-label');
        if (!span) {
          for (var i = 0; i < sb.childNodes.length; i++) {
            var c = sb.childNodes[i];
            if (c.nodeType === 3 && c.nodeValue.trim()) { c.nodeValue = ''; }
          }
          span = document.createElement('span');
          span.className = 'loela-sort-label';
          sb.insertBefore(span, sb.firstChild);
        }
        var t = 'Trier : ' + name;
        if (span.textContent !== t) span.textContent = t;
      }
    }
  }

  function run() {
    stars();
    if (document.querySelector('.product-info')) {
      colons(); tallMedia(); club(); stickyPrice(); lastPiece();
    }
    if (document.querySelector('.collection-toolbar')) toolbar();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }

  function start() {
    run();
    if (window.MutationObserver) {
      /* #main : les filtres et le changement de modèle remplacent des sections entières */
      var targets = document.querySelectorAll('#main, .announcement-bar');
      var mo = new MutationObserver(schedule);
      Array.prototype.forEach.call(targets, function (t) { mo.observe(t, { childList: true, subtree: true, characterData: true }); });
    }
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) loelaVariant = String(e.detail.variant.id);
      setTimeout(run, 60);
    });
    /* l'appli fidélité injecte sa ligne après le chargement */
    var tries = 0;
    (function poll() { club(); if (tries++ < 40 && !document.querySelector('.loela-reassure__club .rmf-points')) setTimeout(poll, 250); else club(); })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
